import React from 'react';
import { AssetsLabel } from './AssetsLabel';
export var QuoteLabel = function QuoteLabel(_ref) {
  var value = _ref.value,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 2 : _ref$decimals,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'EUR' : _ref$currency,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold;
  var props = {
    value: value,
    decimals: decimals,
    currency: currency,
    bold: bold,
    scale: 'one'
  };
  return React.createElement(AssetsLabel, props);
};